const EventEmitter = require('eventemitter3');
import getUnitState from '../../../isomorphic-helpers/getUnitState';
const BattleCalc = require('../../BattleCalc');
const Faerie = require('../../../models/game_pieces/ai_units/summoned_units/Faerie');
const SummonedCondition = require('../../conditions/SummonedCondition');
const { logError } = require('../../logger');
const DeathEvent = require('../../events/DeathEvent');
const { v4: uuidv4 } = require('uuid');

export default function SummonFaerie(battleState) {
  this.handle = 'summon_faerie';
  this.magic = true;
  this.help = true;

  this.eventEmitter = new EventEmitter();

  this.isLegal = function (actor, victim) {
    return victim.tile && !victim.occupied;
  };

  this.execute = function (actor, victim) {
    if (!actor || !actor.inPlay || !victim) {
      return { success: false };
    }

    try {
      var ability = BattleCalc.getEquippedAbility(actor, this.handle);

      // kill faeries on the board if above max
      const mySummoned = Object.values(battleState?.allUnits).filter(
        (unit) => unit.handle === 'faerie' && unit.ownerId === actor.uid
      );
      const summoned_total_after_cast = mySummoned.length + 1;
      let max_num_summoned = BattleCalc.getMaxNumSummons({
        ability_handle: ability.handle,
        caster_build: actor,
      });
      if (summoned_total_after_cast > max_num_summoned) {
        const num_to_kill = summoned_total_after_cast - max_num_summoned;
        for (let i = 0; i < num_to_kill; ++i) {
          const random_index = Math.floor(Math.random() * mySummoned.length);
          const [summoned_to_kill] = mySummoned.splice(random_index, 1);
          new DeathEvent(battleState).execute(summoned_to_kill);
        }
      }

      const faerie = Faerie(ability.potency, actor);
      faerie.ability_trees = faerie.getAbilityTrees();
      faerie.attributes = { base: faerie.getBaseAttributes() };
      const faerie_unit_state = getUnitState({ ai_unit: faerie });
      faerie_unit_state.uid = uuidv4();
      faerie_unit_state.ownerId = actor.uid;
      faerie_unit_state.x = victim.x;
      faerie_unit_state.y = victim.y;

      battleState.registerNewUnit(faerie_unit_state);
      battleState.onUnitCondition(
        new SummonedCondition(actor, faerie_unit_state, battleState, ability.duration)
      );

      var result = { faerie: faerie_unit_state };
      result.abilityHandle = this.handle;
      result.actorId = actor.uid;
      result.victimId = victim.uid;
      result.allPieces = battleState.allPieces;
      this.eventEmitter.emit('result', result);
    } catch (err) {
      logError(err, {
        module: 'SummonFaerie',
        func: 'execute',
        actor,
        victim,
      });

      return { success: false };
    }
  };
}
